import type { ChatRoomResponseLastMessageBasicInfoAllOf } from './chatRoomResponseLastMessageBasicInfoAllOf';
import type { ChatRoomResponseLastMessageBasicInfoAllOfTwo } from './chatRoomResponseLastMessageBasicInfoAllOfTwo';

export type ChatRoomResponseLastMessageBasicInfo = ChatRoomResponseLastMessageBasicInfoAllOf & ChatRoomResponseLastMessageBasicInfoAllOfTwo;
